import React from 'react';

interface HashtagListProps {
    hashState: string[];
}

const HashtagList: React.FC<HashtagListProps> = ({ hashState }) => {
    return (
        <div>
            <ul className="flex flex-row flex-wrap items-center">
                {hashState?.map((tag, i) => (
                    <li key={i}>
                        <div className="flex flex-row items-center justify-center rounded bg-amber-400 text-black text-xs font-semibold mr-4 p-1">
                            #{tag}
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default HashtagList;